import { createRouter, createWebHistory, type RouteRecordSingleView } from 'vue-router';

import authGuard from '@/router/guards/auth';
import { routes } from '@/router/routes';

import LoginView from '@/views/LoginView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      ...routes[0] as RouteRecordSingleView,
      component: LoginView,
    },
    ...routes.slice(1),
  ],
});

router.beforeEach(authGuard);

export default router;
